import client from '../session/apiClient';

/**
 *
 * @param {boolean} includeNonPublicProviders? - include weird providers, such as one-offs for clients like MoneyTree
 * @return {Promise.<Array.<ContentProvider>>}
 */
export function getProviders(includeNonPublicProviders) {
  return client
    .get(`/dashboard/providers/all`, {params: {includeNonPublicProviders: includeNonPublicProviders}})
    .then(response => response.data)
}

/**
 *
 * @param {string} groupId - a legacy group id
 * @param {string} type - see constants in ./ProviderFeature.js
 * @return {Promise.<Array.<ContentProvider>>}
 */
export function getProvidersByGroupAndType(groupId, type) {
  return client
    .get(`/dashboard/providers/${type}/group/${groupId}`)
    .then(response => response.data)
}

export function getSearchAnalyticsProviders() {
  return client
    .get(`/v5/searchAnalytics/providers/`,)
    .then(response => response.data);
};
